export const DEFAULT_COLOR = '#FFFFFF'
